export enum TemplateFormErrorActions {
    SAVE_ERRORS = 'templateFormErrors/SAVE_ERRORS',
    RESET_ERROR = 'templateFormErrors/RESET_ERROR',
}
export const saveTemplateFormError = (payload: Record<string, any>) => ({
    payload,
    type: TemplateFormErrorActions.SAVE_ERRORS,
})
export const resetTemplateFormError = () => ({
    type: TemplateFormErrorActions.RESET_ERROR,
})
